﻿import { useEffect } from 'react';

interface PageTitleProps {
    title: string;
}

// Browser tab page title
export function PageTitle({ title }: PageTitleProps) {

    useEffect(() => {

        document.title = title;

    }, [title]);

    return null;

}